import React from 'react';
import { motion } from 'framer-motion';
import { Section, fadeIn } from './ui/Section';
import { Clock, Calendar, Repeat } from 'lucide-react';
export function HowToUseSection() {
  return <Section className="bg-slate-50" data-id="element-195">
      <div className="max-w-4xl mx-auto" data-id="element-196">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-12 text-center" data-id="element-197">
          Cómo se usa (para que funcione)
        </h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-198">
          {[{
          icon: Clock,
          title: '12-15 min/día',
          desc: 'No necesitas horas. Solo concentración total por 15 minutos.'
        }, {
          icon: Calendar,
          title: '1 escena por día',
          desc: 'Durante 14 días. Domina una situación a la vez.'
        }, {
          icon: Repeat,
          title: 'Repetición en voz alta',
          desc: 'Hasta que la respuesta salga automática, sin pensar.'
        }].map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="text-center" data-id="element-199">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-md text-blue-600 border border-slate-100" data-id="element-200">
                <step.icon className="w-8 h-8" data-id="element-201" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-202">
                {step.title}
              </h3>
              <p className="text-slate-600" data-id="element-203">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}